import { useCallback, useEffect } from 'react';

const useAutoResize = (textareaRef, value) => {
    const adjustHeight = useCallback(() => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = "auto";
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    }, [textareaRef]);
    useEffect(() => {
        adjustHeight();
    }, [value, adjustHeight]);
    return adjustHeight;
};

export { useAutoResize };
